module.exports = __webpack_public_path__ + "img/career2.ce65819c.png";